import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  inApp: false,
  useDesktopLayout: true,
  debug: false,
});

export const setInApp = createAction('SET_IN_APP');
export const setDebug = createAction('SET_DEBUG');
export const setUseDesktopLayout = createAction('SET_USE_DESKTOP_LAYOUT');

const reducers = createReducer({
  [setInApp]: (state, inApp) => state.merge({
    inApp,
  }),
  [setDebug]: (state, debug) => state.merge({
    debug,
  }),
  [setUseDesktopLayout]: (state, useDesktopLayout) => state.merge({ useDesktopLayout }),
}, INITIAL_STATE);

export default reducers;
